module.exports = __webpack_public_path__ + "static/media/artist_09.2ae15727.png";